import '@fortawesome/fontawesome-pro/css/all.min.css';
import '@fortawesome/fontawesome-pro/css/sharp-solid.min.css';
import { createGqlClient } from 'GqlClient';
import { useBrowserTrackerId } from 'hooks/useBrowserTrackerId';
import { useIsBot } from 'hooks/useIsBot';
import { usePageViewTracking } from 'hooks/usePageViewTracking';
import 'index.css';
import { AppProps } from 'next/app';
import { useMemo } from 'react';
import { createSessionManager } from 'sessions/createSessionManager';
import { createTracker } from 'tracking/createTracker';
import { TrackerContext } from 'tracking/useTracker';
import '../styles/globals.css';

function App({ Component, pageProps, router }: AppProps) {
  const isBot = useIsBot();
  const browserTrackerId = useBrowserTrackerId();
  const client = useMemo(() => createGqlClient(browserTrackerId), [browserTrackerId]);
  const sessionManager = useMemo(createSessionManager, []);
  const tracker = useMemo(
    () => createTracker({ browserTrackerId, client, isBot, sessionManager }),
    [browserTrackerId, client, isBot, sessionManager]
  );
  usePageViewTracking(router, tracker);

  return (
    <TrackerContext.Provider value={tracker}>
      <Component {...pageProps} />
    </TrackerContext.Provider>
  );
}

export default App;
